export default (values) => {

  const errors = {};

  if (!values.date) errors.date = true;
  
  return errors;
  
}